
import { AssistantPhotoRounded } from "@mui/icons-material";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import moment from "moment";
import React, { ComponentState, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DatePickerKendoRct from "src/control-components/date-picker/date-picker";
import DropDownKendoRct from "src/control-components/drop-down/drop-down";
import InputKendoRctV1 from "src/control-components/input/inputV1";
import TextAreaKendo from "src/control-components/kendo-text-area/kendo-text-area";
import TextAreaKendoRct from "src/control-components/text-area/text-area";
import { SaveDefaultClientObj } from "src/dataModels/clientDataModel";
import { AddDocGoalReq, AddDocGoalReqObjective2, DropDownObjectWithString, GoalTemplateList, Interventions, TemplateGoalsInfo } from "src/dataModels/docListModel";
import { getTpStaffTypeDll, loaderAction } from "src/redux/actions";
import { ClientService } from "src/services/clientService";
import { clientServices } from "src/services/clientServices";
import { customAxios } from "src/services/useExPressApi";
import { json } from "stream/consumers";
import { filterBy } from "@progress/kendo-data-query";
import MultiSelectDropDown from "src/control-components/multi-select-drop-down/multi-select-drop-down";

export interface AddClientDetailsProps {
    selectedClient: DropDownObjectWithString
    onDataStateISChanged(id: string, data: AddDocGoalReq[], treatmentPlanTemplateId?: number): void
    isEdit: boolean
    isDraft?: boolean
    tpId?: number
    preselectedData: AddDocGoalReq[]
    preselectedDataDraft?: AddDocGoalReq[]
    goalTemplateList: GoalTemplateList[]
}


const AddGoals = (props: AddClientDetailsProps) => {
    const state: ComponentState = useSelector(states => {
        return states;
    });
    const { staffTypeList } = state['ClientReducer']

    const frequencyData = [
        { key: "Daily", value: "Daily" },
        { key: "Weekly", value: "Weekly" },
        { key: "Monthly", value: "Monthly" },
        { key: "Bi-Monthly", value: "Bi-Monthly" },
        { key: "Semi-Annually", value: "Semi-Annually" },
        { key: "Quarterly", value: "Quarterly" },
        { key: "Yearly", value: "Yearly" },

    ];
    const cletreatmentPlanObj: AddDocGoalReq[] = [{ objectives: [{ interventions: [{ freq: frequencyData[0].value }] }] }]
    const [goalList, setGoalList] = useState<AddDocGoalReq[]>(cletreatmentPlanObj)
    const [tpServicetypes, setTpServiceTypes] = useState([])
    const [isTpFetched, setTpFetched] = useState(false)
    const [selectedTemplate, setSelectedTemplate] = useState<any>(undefined)
    const [isAccepted, setIsAccepted] = useState(false)
    const [staffTypesList, setStaffTypesList] = useState([]);

    const dispatch = useDispatch()
    const [filter, setFilter] = useState<any>();
    useEffect(() => {
        if (!isTpFetched) {
            getTpServicetypes()
            setTpFetched(true)
        }
    }, [isTpFetched])

    useEffect(() => {
        if (!isAccepted) {
            dispatch(getTpStaffTypeDll())
            setIsAccepted(true)
        }
    }, [])

    useEffect(() => {
        if (staffTypeList && staffTypeList?.length > 0) {
            const transformedStaffTypes = staffTypeList.map(({ id, typeName }) => ({ id, name: typeName }));
            setStaffTypesList(transformedStaffTypes)
        }
    }, [staffTypeList])

    const getTpServicetypes = async () => {
        await ClientService.getTpServicetypes()
            .then(result => {
                let TpServicetypes = result?.resultData
                setTpServiceTypes(TpServicetypes)
            }).catch(error => {
                // renderErrors(error);
            });
    }

    useEffect(() => {
        props.onDataStateISChanged(props.selectedClient.id, goalList)
    }, [goalList])

    useEffect(() => {

        if (!selectedTemplate && props.tpId && props.tpId != 0 && props.goalTemplateList && props.goalTemplateList.length > 0) {
            props.onDataStateISChanged(props.selectedClient.id, goalList, props.tpId)
            const currentControll = props.goalTemplateList.find((item) => item.id === props.tpId)
            setSelectedTemplate(currentControll)
        }
    }, [props.tpId, selectedTemplate, props.goalTemplateList])



    useEffect(() => {
        if (props.isEdit) {
            setGoalList(props.preselectedData)
        }
    }, [props.isEdit])

    useEffect(() => {

        if (props.isDraft && props.preselectedDataDraft && props.preselectedDataDraft.length > 0) {
            setGoalList([])
            props.preselectedDataDraft.map((selectedDx) => {
                const itemToCreate = {
                    ...selectedDx,
                    targetDate: selectedDx?.targetDate && new Date(selectedDx?.targetDate),
                    startDate: selectedDx?.startDate && new Date(selectedDx?.startDate),
                    objectives: (selectedDx?.objectives && selectedDx?.objectives != null) ? selectedDx?.objectives : [{ interventions: [{}] }]
                }
                setGoalList(prevArray => [...prevArray, itemToCreate])
            })


        }
    }, [props.isDraft])

    const handleGoalTemplateSelection = async (listGoals: TemplateGoalsInfo[]) => {
        if (listGoals && listGoals.length > 0) {
            if (goalList.length == 1 && (!goalList[0].goalName)) {
                setGoalList([])
            }
            dispatch(loaderAction(true))
            const driveResp = await listGoals.map(async (selectedGoal) => {
                var goalDetail = await clientServices.getDefaultGoalDataById(selectedGoal.defaultGoalId)
                if (goalDetail && goalDetail.resultData) {
                    const myRespObj: SaveDefaultClientObj = goalDetail.resultData;
                    const targetDate = myRespObj?.startDate;
                    // const dateGoal = new Date(moment(targetDate).format('M/D/YYYY'))
                    const startGoalDate = new Date(moment(targetDate).format('M/D/YYYY'))

                    let finalGoalObj: AddDocGoalReq = {
                        goalName: myRespObj.goalName,
                        goalDescription: myRespObj.goalDescription,
                        // targetDate: dateGoal && dateGoal,
                        startDate: startGoalDate && startGoalDate
                    }


                    const objective = myRespObj.defaultGoalObjective;
                    let objectiveArr: AddDocGoalReqObjective2[] = []
                    objective.map((objOb) => {
                        const interventionsArray = objOb.defaultGoalObjectiveInterventions;
                        let myArr: Interventions[] = []
                        if (interventionsArray) {
                            interventionsArray?.map((intItems) => {
                                const staffTypeList = intItems.staffTypeDetails ?
                                    intItems.staffTypeDetails.map(({ staffTypeId, typeName }) => ({ id: staffTypeId, name: typeName })) : [];
                                const ServiceTypesList= intItems.serviceTypeDetails ? intItems.serviceTypeDetails.map(({serviceTypeId, serviceTypes})=>({serviceTypeId: serviceTypeId, serviceTypes: serviceTypes })):[];
                                myArr.push({
                                    freq: intItems.freq, numFreq: intItems.numFreq,
                                    intervention: intItems.intervention,
                                    serviceTypes:ServiceTypesList,
                                    staffTypes: staffTypeList
                                })
                            })
                        }

                        objectiveArr.push({ ...objOb, interventions: myArr })
                    })
                    finalGoalObj = { ...finalGoalObj, objectives: objectiveArr }
                    setGoalList(oldGoals => [...oldGoals, finalGoalObj])
                }
            })
            if (driveResp) {
                dispatch(loaderAction(false))
            }
            
        }

    }
    function onFilterChange(event, listName) {
        setFilter({ ...filter, [listName]: event.filter });
    }

    function renderToItem(li, itemProps) {
        const itemChildren = (
            <span>
                <input
                    type="checkbox"
                    name={itemProps.dataItem}
                    checked={itemProps.selected}
                    onChange={(e) => itemProps.onClick(itemProps.index, e)}
                />
                &nbsp;{li.props.children}
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    }

    return (<div>
        <div className="my-4 hrBorder ">
            <div className="d-flex align-items-center justify-content-between">
                <h4 className="address-title text-grey ">
                    <span className="f-24"> {`Goals for ${props.selectedClient.name}`}</span>
                </h4>

            </div>


            {/* {!props.isEdit && */}
            <div>
                <h6 className="k-label mt-2">Select Treatment Plan Template (Pre-fill below Goals from Treatment Plan Template)</h6>
                <DropDownList
                    className="templateIcon"
                    filterable={true}
                    data={filterBy(props.goalTemplateList, (filter && filter.templateList) && filter.templateList)}
                    onFilterChange={(event) => {
                        onFilterChange(event, "templateList");
                    }}
                    textField="templateName"
                    name="selectedTemplate"
                    value={selectedTemplate}
                    onChange={(event) => {
                        setSelectedTemplate(event.target.value)
                        props.onDataStateISChanged(props.selectedClient.id, event.target.value.templateGoalsInfo, event.target.value.id)
                        handleGoalTemplateSelection(event.target.value.templateGoalsInfo)
                    }}
                    dataItemKey="id"

                />
            </div>
            {/* } */}
            {
                goalList.map((selectedGoal, indexGoal) =>
                    <div className="pieGoal boxSHADOWADD">
                        <div className="row mt-3 borderTop align-items-center">
                            <div className="mb-2 col-lg-6 col-md-6  position-relative">
                                <TextAreaKendo
                                    txtValue={selectedGoal.goalName}
                                    onChange={(handleTextChange) => {
                                        setGoalList(list => list.map((item, i) =>
                                            i === indexGoal
                                                ? {
                                                    ...item,
                                                    goalName: handleTextChange.value!
                                                }
                                                : item
                                        ));
                                    }
                                    }

                                    name="custAuthId"
                                    label="Goal Name"
                                    resizable={true}
                                />
                            </div>



                            <div className="mb-2 col-lg-6 col-md-6 col-6">
                                <TextAreaKendoRct
                                    name="goalDescription"
                                    txtValue={selectedGoal.goalDescription}
                                    onChange={(handleTextChange) => {
                                        setGoalList(list => list.map((item, i) =>
                                            i === indexGoal
                                                ? {
                                                    ...item,
                                                    goalDescription: handleTextChange.value!
                                                }
                                                : item
                                        ));
                                    }}
                                    label="Description"
                                    resizable={true}
                                />
                            </div>

                            <div className="col-lg-6 col-md-6 custom-service-input">

                                <DatePickerKendoRct
                                    placeholder=""
                                    name={"startDate"}
                                    value={selectedGoal?.startDate && selectedGoal?.startDate}
                                    onChange={(selectedClientDate) => {
                                        setGoalList(list => list.map((item, i) =>
                                            i === indexGoal
                                                ? {
                                                    ...item,
                                                    startDate: selectedClientDate?.value!
                                                }
                                                : item
                                        ));
                                    }}

                                    title={"Start Date"}
                                    label={"Start Date"}
                                    required={true}
                                />
                            </div>

                            <div className="col-lg-5 col-md-5 custom-service-input">

                                <DatePickerKendoRct
                                    placeholder=""
                                    name={"targateDate"}
                                    value={selectedGoal?.targetDate && selectedGoal?.targetDate}
                                    onChange={(selectedClientDate) => {
                                        setGoalList(list => list.map((item, i) =>
                                            i === indexGoal
                                                ? {
                                                    ...item,
                                                    targetDate: selectedClientDate?.value!
                                                }
                                                : item
                                        ));
                                    }}

                                    title={"Target Date"}
                                    label={"Target Date"}
                                    required={true}
                                />
                            </div>


                            {(goalList.length > 0) && <div className="col-lg-1 col-md-1  col-sm-1 mb-2 ">
                                <button className="btn-transaprent  ">
                                    <i onClick={
                                        () => {
                                            setGoalList(goalList.filter((item, i) => i !== indexGoal));
                                        }
                                    }
                                        className="fa-solid fa-trash cross-red"></i>
                                    {/* 
<i class="fa-solid fa-trash"></i> */}
                                </button>
                            </div>
                            }
                        </div>




                        {/* Here starts the Objective Part */}
                        <div className="pieGoal">
                            {

                                selectedGoal?.objectives?.map((selectedObjective, indexObjective) =>
                                    <div className="row mt-3 borderTop">
                                        <div className="mb-2  col-md-6 col-12 position-relative">
                                            <TextAreaKendo
                                                txtValue={selectedObjective.objective}
                                                onChange={(handleTextChange) => {
                                                    const currentObjective = selectedGoal.objectives;
                                                    currentObjective![indexObjective].objective = handleTextChange.value!

                                                    setGoalList(list => list.map((item, i) =>
                                                        i === indexGoal
                                                            ? {
                                                                ...item,
                                                                objectives: currentObjective!
                                                            }
                                                            : item
                                                    ));
                                                }
                                                }
                                                name="custAuthId"
                                                label="Objective"
                                                resizable={true}
                                            />

                                            {(selectedGoal.objectives && selectedGoal.objectives.length > 0)
                                                && <button className=" btn-transaprent">
                                                    <i onClick={
                                                        () => {
                                                            const objectivesOfGoal = selectedGoal.objectives;
                                                            const removeIndexedItem = objectivesOfGoal?.filter((item, i) => i !== indexObjective)
                                                            setGoalList(list => list.map((item, i) =>
                                                                i === indexGoal
                                                                    ? {
                                                                        ...item,
                                                                        objectives: removeIndexedItem!
                                                                    }
                                                                    : item
                                                            ));
                                                        }
                                                    }
                                                        className="fa-solid fa-xmark cross-red"></i>
                                                </button>}


                                        </div>

                                        <div className="pieGoal col-md-6 col-12">
                                            {
                                                selectedObjective?.interventions?.map((selectedIntervention, indexIntervention) =>
                                                    <>
                                                        <div className="position-relative intervationButton mb-2">
                                                            <TextAreaKendo
                                                                txtValue={selectedIntervention.intervention}
                                                                onChange={(handleTextChange) => {

                                                                    const interventionList = selectedObjective.interventions;
                                                                    interventionList![indexIntervention].intervention = handleTextChange.value;
                                                                    const currentObjective = selectedGoal.objectives;
                                                                    currentObjective![indexObjective]!.interventions = interventionList!

                                                                    setGoalList(list => list.map((item, i) =>
                                                                        i === indexGoal
                                                                            ? {
                                                                                ...item,
                                                                                objectives: currentObjective!
                                                                            }
                                                                            : item
                                                                    ));
                                                                }
                                                                }
                                                                name="custAuthId"
                                                                label="Interventions"
                                                                resizable = {true}
                                                            />

                                                            <div className="col-md-12 col-12 pl-0 custom-service-input" >
                                                                <MultiSelectDropDown
                                                                    label="Service Type"
                                                                    value={selectedIntervention.serviceTypes}
                                                                    textField="serviceTypes"
                                                                    name="serviceTypeId"
                                                                    data={tpServicetypes}
                                                                    dataItemKey="serviceTypeId"
                                                                    autoClose={false}
                                                                    onChange={(e: any) => {
                                                                        const interventionList = selectedObjective.interventions;
                                                                        interventionList![indexIntervention].serviceTypes = e.target.value;
                                                                        const currentObjective = selectedGoal.objectives;
                                                                        currentObjective![indexObjective]!.interventions = interventionList!
                                                                        setGoalList(list => list.map((item, i) =>
                                                                            i === indexGoal
                                                                                ? {
                                                                                    ...item,
                                                                                    defaultGoalObjective: currentObjective!,


                                                                                }
                                                                                : item
                                                                        ));
                                                                    }}
                                                                    itemRender={renderToItem}
                                                                />
                                                            </div>
                                                            <div className="col-md-12 col-12 pl-0 custom-service-input" >
                                                                <MultiSelectDropDown
                                                                    label="Staff Type"
                                                                    value={selectedIntervention.staffTypes}
                                                                    textField="name"
                                                                    name="staffType"
                                                                    data={staffTypesList}
                                                                    dataItemKey="id"
                                                                    autoClose={false}
                                                                    onChange={(e: any) => {
                                                                        const interventionList = selectedObjective.interventions;
                                                                        interventionList![indexIntervention].staffTypes = e.target.value;
                                                                        const currentObjective = selectedGoal.objectives;
                                                                        currentObjective![indexObjective]!.interventions = interventionList!
                                                                        setGoalList(list => list.map((item, i) =>
                                                                            i === indexGoal
                                                                                ? {
                                                                                    ...item,
                                                                                    defaultGoalObjective: currentObjective!,


                                                                                }
                                                                                : item
                                                                        ));
                                                                    }}
                                                                    itemRender={renderToItem}

                                                                />
                                                            </div>
                                                            <div className='col-md-12 pl-0'>
                                                                {/* <div className="frequency mb-3"> */}
                                                                {/* <div className="row "> */}
                                                                {/* <div className="col-md-12"> */}
                                                                <label className="mb-0">Frequency</label>
                                                                {/* </div> */}
                                                                {/* </div> */}
                                                                <div className="mt-0">
                                                                    <div className="col-md-12 d-flex mt-0 p-0">
                                                                        <div className='col-md-6 pl-0 custom-frequency-input '>
                                                                            <InputKendoRctV1
                                                                                value={selectedIntervention.numFreq && selectedIntervention.numFreq}
                                                                                onChange={(handleTextChange) => {

                                                                                    const interventionList = selectedObjective.interventions;
                                                                                    interventionList![indexIntervention].numFreq = handleTextChange.value;
                                                                                    const currentObjective = selectedGoal.objectives;
                                                                                    currentObjective![indexObjective]!.interventions = interventionList!

                                                                                    setGoalList(list => list.map((item, i) =>
                                                                                        i === indexGoal
                                                                                            ? {
                                                                                                ...item,
                                                                                                defaultGoalObjective: currentObjective!
                                                                                            }
                                                                                            : item
                                                                                    ));
                                                                                }}

                                                                                className="w-100 width-input"
                                                                                style={{ width: "100% !important" }}
                                                                                required={true}


                                                                            />
                                                                        </div>

                                                                        <div className='col-md-6 pr-0 custom-frequency-input '>
                                                                            <DropDownList
                                                                                data={frequencyData}
                                                                                textField="value"
                                                                                dataItemKey="key"
                                                                                // defaultItem={frequencyData[0]}
                                                                                value={selectedIntervention.freq ? frequencyData.filter(obj => {
                                                                                    return obj.value === selectedIntervention.freq;

                                                                                })[0] : frequencyData[0]}
                                                                                onChange={(e) => {

                                                                                    const interventionList = selectedObjective.interventions;
                                                                                    interventionList![indexIntervention].freq = e.target.value.value;
                                                                                    const currentObjective = selectedGoal.objectives;
                                                                                    currentObjective![indexObjective]!.interventions = interventionList!
                                                                                    setGoalList(list => list.map((item, i) =>
                                                                                        i === indexGoal
                                                                                            ? {
                                                                                                ...item,
                                                                                                defaultGoalObjective: currentObjective!
                                                                                            }
                                                                                            : item
                                                                                    ));
                                                                                }}
                                                                                name="freq"
                                                                                className="w-100 width-input frequency-drop "
                                                                                style={{ width: "100% !important" }}
                                                                                required={true}
                                                                            // error={!fields.freq && errors.freq}
                                                                            />
                                                                            {/* {!fields.freq && <Error>{errors.freq}</Error>} */}
                                                                        </div>
                                                                    </div>
                                                                </div></div>


                                                            {(selectedObjective.interventions && selectedObjective.interventions.length > 0)
                                                                && <button className="btn-transaprent">
                                                                    <i onClick={
                                                                        () => {
                                                                            const interventionList = selectedObjective.interventions;
                                                                            const removeIndexedItem = interventionList?.filter((item, i) => i !== indexIntervention)
                                                                            const currentObjective = selectedGoal.objectives;
                                                                            currentObjective![indexObjective]!.interventions = removeIndexedItem

                                                                            setGoalList(list => list.map((item, i) =>
                                                                                i === indexGoal
                                                                                    ? {
                                                                                        ...item,
                                                                                        objectives: currentObjective!
                                                                                    }
                                                                                    : item
                                                                            ));
                                                                        }
                                                                    }
                                                                        className="fa-solid fa-xmark cross-red"></i>
                                                                </button>}
                                                        </div>


                                                    </>
                                                )

                                            }
                                            <div className="text-right">
                                                <button
                                                    onClick={() => {
                                                        const currentListInterventions = selectedObjective.interventions;
                                                        currentListInterventions?.push({})
                                                        const currentList = selectedGoal.objectives;
                                                        currentList![indexObjective].interventions = currentListInterventions
                                                        setGoalList(list => list.map((item, i) =>
                                                            i === indexGoal
                                                                ? {
                                                                    ...item,
                                                                    objectives: currentList
                                                                }
                                                                : item
                                                        ));
                                                    }
                                                    }
                                                    className="AddMore"><i className="fa-solid fa-plus"></i> Add Interventions</button>
                                            </div>
                                        </div>

                                    </div>



                                )



                            }




                        </div>

                        <div className="text-right col-md-6">
                            <button
                                onClick={() => {
                                    const currentList = selectedGoal.objectives;
                                    currentList?.push({ interventions: [{ freq: frequencyData[0].value }] })
                                    setGoalList(list => list.map((item, i) =>
                                        i === indexGoal
                                            ? {
                                                ...item,
                                                objectives: currentList
                                            }
                                            : item
                                    ));
                                }
                                }

                                className="AddMore"><i className="fa-solid fa-plus"></i> Add Objectives
                            </button>
                        </div>

                    </div>

                )


            }




            <button
                onClick={() => {
                    setGoalList(oldArray => [...oldArray, { objectives: [{ interventions: [{ freq: frequencyData[0].value }] }] }]);
                }}
                className="AddMore mt-3"><i className="fa-solid fa-plus"></i> Add Another Goal</button>
        </div>

    </div>)
};

export default AddGoals;